<template>
  <div>
    <div class="vx-col w-full">
      <ul class="heading-ul mb-5">
        <li>
          <router-link to="/user-shift-mapping" class="vx-row">
            <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            <h4>{{ $t("setup.label.ViewUserWorkingShift") }}</h4>
          </router-link>
        </li>
      </ul>
    </div>
    <ValidationObserver ref="observer">
      <div class="vx-row">
        <vx-card title no-shadow card-border>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <small class="date-label font-semibold">{{
                $t("setup.label.TeamName")
              }}</small>
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                name="team id"
              >
                <v-select
                  label="item"
                  :options="teamCodes"
                  v-model="teamName"
                  placeholder="--Select One--"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full mb-2"
                  disabled
                >
                  <template v-slot:option="option">{{ option.item }}</template>
                </v-select>
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <small class="date-label font-semibold">{{
                $t("setup.label.Shift")
              }}</small>
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                name="team id"
              >
                <v-select
                  label="item"
                  :options="teamCodes"
                  v-model="shift"
                  placeholder="--Select One--"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full mb-2"
                  disabled
                >
                  <template v-slot:option="option">{{ option.item }}</template>
                </v-select>
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="dual-listbox-wrapper">
            <div class="listbox">
              <div class="listbox-header">
                <h6 class="text-left font-bold">
                  {{ $t("setup.label.AvailableUsers") }}
                </h6>
                <input
                  v-model="searchSource"
                  :placeholder="$t('setup.label.Search')"
                  class="border search-box rounded p-2 w-1/2"
                />
              </div>
              <ul class="listbox-body">
                <li
                  v-for="plan in filteredSourceUsers"
                  :key="plan.id"
                  :class="[
                    'listbox-item',
                    selectedSourceUsers === plan.id ? 'active' : '',
                  ]"
                  @click="selectedSourceUsers = plan.id"
                >
                  {{ plan.username }}
                </li>
              </ul>
            </div>

            <div class="arrow-buttons">
              <button
                class="arrow-button"
                :disabled="!selectedSourceUsers"
                @click="moveToTarget"
              >
                <feather-icon icon="ArrowRightIcon" svgClasses="text-dark" />
              </button>
              <button
                class="arrow-button"
                :disabled="!selectedTargetUsers"
                @click="moveToSource"
              >
                <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
              </button>
            </div>

            <div class="listbox">
              <div class="listbox-header">
                <h6 class="text-left font-bold">
                  {{ $t("setup.label.SelectedUsers") }}
                </h6>
                <input
                  v-model="searchTarget"
                  :placeholder="$t('setup.label.Search')"
                  class="border search-box rounded p-2 w-1/2"
                />
              </div>
              <ul class="listbox-body">
                <li
                  v-for="plan in filteredTargetUsers"
                  :key="plan.id"
                  :class="[
                    'listbox-item',
                    selectedTargetUsers === plan.id ? 'active' : '',
                  ]"
                  @click="selectedTargetUsers = plan.id"
                >
                  {{ plan.username }}
                </li>
              </ul>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="cancel"
            >{{ $t("setup.label.Cancel") }}</vs-button
          >
          <vs-button
            class="mr-3 mb-2 footerButton-next"
            @click="editTicketUsers"
            >{{ $t("setup.label.Submit") }}</vs-button
          >
        </div>
      </div>
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { mapState } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";

const ticketEmptyObj = {
  locale: "en",
  teamId: 0,
  userId: [],
};

export default {
  data() {
    return {
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      ticketData: ticketEmptyObj,
      added: false,
      statuses: ["ACTIVE", "INACTIVE"],
      checked: true,
      data: {},
      addedUsers: [],
      userIds: [],
      userNames: [],
      TicketTeamMappingData: [],
      availableUsers: [],
      selectedUsers: [],
      selectedUsersData: [],
      selectedUserIds: [],
      iconSel: "icon-plus",
      username: "",
      teamCode: "",
      usersInit: {},
      selectedSourceUsers: null,
      selectedTargetUsers: null,
      searchSource: "",
      searchTarget: "",

      teamName: "",
      shift: "",
    };
  },
  components: {
    "v-select": vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  computed: {
    ...mapState({
      template: (state) => state.teams.teamuserTemplate,
      teamUserById: (state) => state.teams.teamUserById,
    }),
    filteredSourceUsers() {
      if (this.usersInit && this.usersInit.sourceUsers) {
        return this.usersInit.sourceUsers.filter((d) =>
          d.username.toLowerCase().includes(this.searchSource.toLowerCase())
        );
      } else {
        return null;
      }
    },
    filteredTargetUsers() {
      if (this.usersInit && this.usersInit.targetUsers) {
        return this.usersInit.targetUsers.filter((d) =>
          d.username.toLowerCase().includes(this.searchTarget.toLowerCase())
        );
      } else {
        return null;
      }
    },
    // teamCodes() {
    //   let tempdata = [];
    //   for (let temp of this.TicketTeamMappingData) {
    //     tempdata.push(temp.teamCode);
    //     if (temp.id == this.id) {
    //       this.teamCode = temp.teamCode;
    //     }
    //   }
    //   return tempdata;
    // },
    teamIds() {
      let tempdata = [];
      for (let temp of this.TicketTeamMappingData) {
        tempdata.push(temp.id);
      }
      return tempdata;
    },
  },
  methods: {
    moveToTarget() {
      if (!this.selectedSourceUsers) return;

      const selectedUser = this.usersInit.sourceUsers.find(
        (e) => e.id === this.selectedSourceUsers
      );

      if (selectedUser) {
        this.usersInit.targetUsers.push(selectedUser);
        this.usersInit.sourceUsers = this.usersInit.sourceUsers.filter(
          (e) => e.id !== this.selectedSourceUsers
        );
        this.selectedSourceUsers = null;
      }
    },

    moveToSource() {
      if (!this.selectedTargetUsers) return;

      const selectedUser = this.usersInit.targetUsers.find(
        (e) => e.id === this.selectedTargetUsers
      );

      if (selectedUser) {
        this.usersInit.sourceUsers.push(selectedUser);
        this.usersInit.targetUsers = this.usersInit.targetUsers.filter(
          (e) => e.id !== this.selectedTargetUsers
        );
        this.selectedTargetUsers = null;
      }
    },
    initializeUsers() {
      const availableUsers =
        (this.ticketData && this.ticketData.availableUsers) || [];
      const selectedUsers =
        (this.ticketData && this.ticketData.selectedUsers) || [];

      const formattedSelectedUsers = selectedUsers.map((user) => ({
        id: user.userId,
        username: user.username,
      }));

      if (formattedSelectedUsers && formattedSelectedUsers.length > 0) {
        const targetUsers = formattedSelectedUsers;
        const sourceUsers = availableUsers;

        this.$set(this, "usersInit", {
          sourceUsers,
          targetUsers,
        });
      } else {
        this.$set(this, "usersInit", {
          sourceUsers: [...availableUsers],
          targetUsers: [],
        });
      }
      this.selectedSourceUsers = null;
      this.selectedTargetUsers = null;
    },

    async editTicketUsers() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      let indx = this.teamCodes.indexOf(this.teamCode);
      this.ticketData.teamId = this.teamIds[indx];
      this.ticketData.userId = this.usersInit.targetUsers.map(
        (plan) => plan.id
      );
      this.ticketData.locale = "en";
      delete this.ticketData.selectedUsers;
      delete this.ticketData.TicketTeamMappingData;
      delete this.ticketData.availableUsers;
      try {
        await this.$store.dispatch("teams/editTeamUserAction", {
          id: this.id,
          data: this.ticketData,
        });
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Ticket Users Updated Successfully!",
          type: "success",
        });
        this.$router.push(`/user-shift-mapping`);
        this.resetForm();
      } catch (e) {
        this.errorMessage = e.message.errors[0].defaultUserMessage.replace(
          "The parameter",
          ""
        );
        this.warningPopup = true;
        this.errors = e.message.errors;
      }
    },

    async getTicketDataTemplate() {
      try {
        await this.$store.dispatch(
          "teams/getShiftMappingIdAction",
          this.$route.params.id
        );
        this.TicketTeamMappingData = this.template.TicketTeamMappingData;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.getTicketUserByID();
    },
    async getTicketUserByID() {
      try {
        await this.$store.dispatch("teams/setTicketUserById", this.id);
        this.ticketData = this.teamUserById;
        this.initializeUsers();
      } catch (e) {
        this.$toasted.error(e.message);
      }
    },
    resetForm() {
      this.ticketData = ticketEmptyObj;
    },
    dataCall() {
      setTimeout(this.getTicketUserByID, 300);
    },
    cancel() {
      this.$router.push("/user-shift-mapping");
    },
  },
  watch: {},

  created() {},
  mounted() {
    this.resetForm();
    this.id = this.$route.params.id;
    this.getTicketDataTemplate();
  },
};
</script>
<style scoped>
.dual-listbox-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding: 20px;
}
.listbox {
  width: -webkit-fill-available;
  height: 300px;
  border: 1px solid #ccc;
  border-radius: 6px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  background: #fff;
  display: flex;
  flex-direction: column;
}
.listbox-header {
  background-color: #2e68b266;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}
.listbox-body {
  overflow-y: auto;
  flex-grow: 1;
  margin: 0;
  padding: 10px;
  list-style: none;
}
.listbox-item {
  padding: 10px;
  cursor: pointer;
  transition: background 0.2s;
}
.listbox-item:hover {
  background-color: #f0f8ff;
}
.listbox-item.active {
  background-color: #e2e9f5;
  font-weight: bold;
}
.arrow-buttons {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.arrow-button {
  padding: 8px;
  border: none;
  background-color: #eee;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  font-size: 0;
}
.arrow-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
